import React from 'react';
import { Flex } from '@this/shared/ui/layout/flex';
import { Radio, RadioGroup } from '@this/shared/ui/inputs/radio';
import { styled } from '@this/constants/themes';
import Button from '@this/shared/atoms/button';

type Props = {
  onSearch: (disabled: boolean) => void;
};

export const ProjectSharesFilter = ({ onSearch }: Props) => {
  const [filterDisabled, setFilterDisabled] = React.useState(false);

  return (
    <Filter className="e2e-share-filter">
      <Flex alignItems="center">
        <FilterLabel>ステータス</FilterLabel>
        <RadioGroup
          layout="horizontal"
          value={filterDisabled}
          onChange={(_, value) => setFilterDisabled(value === 'true')}
        >
          <Radio name="status" value={false}>
            有効
          </Radio>
          <Radio name="status" value>
            無効
          </Radio>
        </RadioGroup>
      </Flex>
      <FilterButton onClick={() => onSearch(filterDisabled)}>検索</FilterButton>
    </Filter>
  );
};

const Filter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
`;

const FilterLabel = styled.label`
  font-weight: normal;
  margin-right: 5px;
`;

const FilterButton = styled(Button)`
  width: 100px;
  margin-left: 16px;
`;
